module.exports = __webpack_public_path__ + "img/birthday.fe0ace45.jpg";